import Spacer from '@/common/components/spacer';
import TestimonialQuote from '@/homepage/components/testimonials/testimonial-quote';
import TestimonialName from '@/homepage/components/testimonials/testimonial-name';
import { Testimonial } from '@/homepage/types/testimonial';

interface TestimonialTileProps {
  testimonial: Testimonial;
}

export default function TestimonialTile({ testimonial }: TestimonialTileProps) {
  return (
    <div className="relative flex h-full w-full flex-1 flex-col items-center justify-start rounded-[16px] border-[1px] border-solid border-flexcar-neutral80 bg-flexcar-neutral100 px-[24px] pb-[20px] pt-[24px] shadow-shadow10">
      <img
        src={testimonial.posterImageURL}
        alt={`${testimonial.name}`}
        className="h-[226px] w-full rounded-[8px] object-cover object-center"
      />

      <div>
        <Spacer variant="height24" />
        <div className="flex flex-grow flex-col justify-between">
          <TestimonialQuote quote={testimonial.quote} variant="tile" />
          <Spacer variant="height16" />
          <TestimonialName name={testimonial.name} />
        </div>
      </div>
    </div>
  );
}
